import { render, staticRenderFns } from "./updataInfo.vue?vue&type=template&id=351771b8&scoped=true"
import script from "./updataInfo.vue?vue&type=script&lang=js"
export * from "./updataInfo.vue?vue&type=script&lang=js"
import style0 from "./updataInfo.vue?vue&type=style&index=0&id=351771b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351771b8",
  null
  
)

export default component.exports